import { type ISmartCallFlowStep } from 'entities/SmartCall/api/types'
import {
  type FlowActionStore,
  generateFlowActionId,
  type IFlowActionStoreProps,
} from 'widgets/Flow'
import { type ISmartCallFlowActionType } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/type'

export type ISmartCallFlowActionStoreProps = IFlowActionStoreProps<ISmartCallFlowActionType>

export const generateSmartCallActionId = (
  id: `${ISmartCallFlowStep['type']}_${ISmartCallFlowStep['id']}`
) => generateFlowActionId(id)

export type ISmartCallActionStore = FlowActionStore<ISmartCallFlowActionType>
